import PullToRefresh from "pulltorefreshjs"

let instance = null

function isConnectedAnchor(element) {
  return !!(element && element.parentNode)
}

export function destroyPullToRefresh() {
  if (!instance) return

  instance.destroy()
  instance = null
}

export function initPullToRefresh() {
  destroyPullToRefresh()

  const mainElement = document.querySelector("#pull-to-refresh")
  if (!isConnectedAnchor(mainElement)) {
    return null
  }

  instance = PullToRefresh.init({
    mainElement,
    onRefresh() {
      window.location.reload()
    }
  })

  // pulltorefreshjs setupDOM does mainElement.parentNode.insertBefore(...)
  // with no null check. After Turbo or choose_rounds XHR replaces the
  // #pull-to-refresh node, a leftover window touchstart would throw.
  const originalContains = instance.contains.bind(instance)
  instance.contains = (target) => {
    if (!isConnectedAnchor(instance.mainElement)) {
      return false
    }
    return originalContains(target)
  }

  return instance
}
